module.exports = __webpack_public_path__ + "img/guanwang_bg_jianjie.555ac127.png";